import {NgModule} from '@angular/core';
import {FeatureGgwFixedRoutesService} from "@catmodels/ggw-fixed-routes/services/feature-ggw-fixed-routes.service";
import { ProjectGgwFixedRouteListComponent } from './components/project-ggw-fixed-route-list/project-ggw-fixed-route-list.component';
import {CommonModule} from "@angular/common";
import {ButtonModule, DataTableModule} from "primeng/primeng";
import {UIBaseModule} from "@catui/ui-base.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {UIFormModule} from "@catuiform/ui-form.module";
import {FeatureGgwFixedRoutesFormComponent} from "@catmodels/ggw-fixed-routes/components/feature-ggw-fixed-routes-form/feature-ggw-fixed-routes-form.component";

const publicComponents = [
  ProjectGgwFixedRouteListComponent,
  FeatureGgwFixedRoutesFormComponent
];

const imports = [
  CommonModule,
  DataTableModule,
  UIBaseModule,
  ButtonModule,
  FormsModule,
  UIFormModule,
  ReactiveFormsModule,
  ];
const declarations = [
  ...publicComponents,
];

const exportings = [...publicComponents];

const providers = [FeatureGgwFixedRoutesService];
const entryComponents = [...publicComponents];

@NgModule({
  declarations,
  entryComponents,
  exports: exportings,
  imports,
  providers,
})
export class GgwFixedRoutesModule {
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/ggw-fixed-routes/ggw-fixed-routes.module.ts